import React              from "react";
import Autocomplete       from "@mui/material/Autocomplete";
import TextField          from "@mui/material/TextField";

function CustomAutocomplete({
  name,
  label,
  options,
  value,
  onChange,
  disabled,
}) {
  const handleChange = (event, newValue) => {
    onChange({ [name]: newValue ? newValue.value : null });
  };

  const selectedOption =
    options.find((option) => option.value === value) || null;

  // Funzione personalizzata per filtrare le opzioni
  // const filterOptions = (options, { inputValue }) => {
  //   return options.filter((option) =>
  //     String(option.label).toLowerCase().startsWith(inputValue.toLowerCase())
  //   );
  // };

   // Funzione personalizzata per filtrare le opzioni
   const filterOptions = (options, { inputValue }) => {
    const lowercasedInput = inputValue.toLowerCase();
    return options.filter(
      (option) =>
        String(option.label).toLowerCase().includes(lowercasedInput) || // Cerca nella label
        String(option.dataFattura || "").toLowerCase().includes(lowercasedInput) // Cerca nella data
    );
  };

  return (
    <Autocomplete
      fullWidth
      options={options}
      value={selectedOption}
      onChange={handleChange}
      disabled={disabled}
      filterOptions={filterOptions}
      // getOptionLabel={(option) => (option?.label ? String(option.label) : "")}
      
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label={label}
          disabled={disabled}
          sx={{
            width: "100%",
            textAlign: "left",
            borderRadius: "10px",
            backgroundColor: "#FFFFFF", 
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "#fda03d",
              },
              "&:hover fieldset": {
                borderColor: "#fda03d", 
              },
              "&.Mui-focused fieldset": {
                borderColor: "#fda03d", 
              },
            },
            "& .MuiOutlinedInput-root.Mui-disabled": {
              bgcolor: "transparent",
              cursor: "not-allowed",
            },
            "& .Mui-disabled": {
              cursor: "not-allowed",
            },
            "& .MuiInputLabel-root.Mui-focused": {
              color: "#fda03d", 
            },
          }}
        />
      )}
    />
  );
}

export default CustomAutocomplete;
